<template>
  <v-app>
    <router-view />
  </v-app>
</template>
<script>

export default {
  name: 'App',
};
</script>

<style>
table > thead > tr > th:nth-child(1) {
  position: sticky !important;
  left: 0;
  z-index: 9998 !important;
  background: white;
}

.row {
  margin: 0 !important;
}
</style>
